export const hidden =  {
  opacity: 0,
  scale: 0
}

export const visible = {
  opacity: 1,
  scale: 1
}
